import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardHeader from '@mui/material/CardHeader';
import Skeleton from '@mui/material/Skeleton';

export function ReportCardSkeleton() {
  return (
    <Card>
      <CardHeader
        avatar={<Skeleton variant="circular" width={40} height={40} />}
        title={<Skeleton variant="text" width="60%" height={24} />}
        subheader={<Skeleton variant="text" width="90%" height={20} />}
      />
      <CardActions sx={{ justifyContent: 'flex-end', pt: 0 }}>
        <Skeleton variant="rounded" width={80} height={30} />
      </CardActions>
    </Card>
  );
}

export default ReportCardSkeleton;
